import * as React from "react";

// True inside a fleet-mode header, for the few nav pieces that swap assets or
// button variants rather than colors (colors flip through the .fleet token scope).
export const FleetHeaderContext = React.createContext(false);

export function useIsFleetHeader() {
    return React.useContext(FleetHeaderContext);
}
